import React from "react";

export default function Cell({ status }: { status: boolean }) {
  return <div className={`cell ${status ? "active-cell" : ""}`}></div>;
}
